/* ============================================================
   KAMAKHYA — Storefront behaviours (vanilla, no dependencies)
   Quantity steppers · AJAX add-to-cart · cart count · variant
   price swap · PDP gallery · collection sort · booking countdown.
   Progressive enhancement: every control still works without JS.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    try {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
    } catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---- Quantity steppers (PDP + cart) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-inc], [data-qty-dec]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('.k-qty__input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var val = parseInt(input.value || '0', 10) || 0;
    val += btn.hasAttribute('data-qty-inc') ? 1 : -1;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Remember which button submitted (older Safari lacks e.submitter) ---- */
  document.addEventListener('click', function (e) {
    var sub = e.target.closest('button[type="submit"], input[type="submit"]');
    var form = sub && sub.closest('.k-pdp__form, .k-cart__form');
    if (form) form.lastSubmitter = sub;
  });

  /* ---- AJAX add to cart ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.k-pdp__form');
    if (!form) return;
    e.preventDefault();
    // Lapsed booking window: the buttons are already disabled or gone, but Enter in
    // the quantity field would still submit, so refuse the add outright.
    if (form.querySelector('[data-countdown].is-over')) return;
    var submitter = e.submitter || form.lastSubmitter;
    // Pooja booking button: add to cart, then go to the cart page — NOT /checkout.
    // Poojas must pass the sankalpa gate (Gotra, name, phone) that lives on the cart
    // page; Shopify's hosted checkout can't collect those fields without Plus, so
    // skipping to /checkout would lose them silently. Keep in sync with the
    // return_to value on the booking button in sections/k-product.liquid.
    var isBook = !!(submitter && submitter.hasAttribute('data-book-now'));
    var btn = isBook ? submitter : form.querySelector('.k-pdp__add');
    var label = isBook ? null : form.querySelector('[data-add-label]');
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        if (isBook) { window.location.href = '/cart'; return; }
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (label) {
          label.textContent = 'Added ✓';
          setTimeout(function () { label.textContent = original; }, 1700);
        }
      })
      .catch(function () {
        // Fall back to a normal form post so the user is never stuck.
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (isBook && !form.querySelector('input[name="return_to"]')) {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'return_to';
          hidden.value = '/cart';
          form.appendChild(hidden);
        }
        form.submit();
      });
  });

  /* ---- Cart: keep the sankalpa panel in view when checkout is blocked ----
     The gate itself is native constraint validation on the required inputs (the Update
     button carries formnovalidate so it opts out), so this works with JS off. All this
     adds is scrolling the panel into view first — otherwise a devotee whose panel is
     off-screen sees the Checkout button do nothing at all. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.k-cart__form');
    if (!form) return;
    // "Update cart" carries formnovalidate and legitimately submits with the sankalpa
    // fields empty — never intercept it, or quantity changes would break.
    var submitter = e.submitter || form.lastSubmitter;
    if (submitter && submitter.formNoValidate) return;
    if (form.checkValidity()) return;
    var panel = form.querySelector('[data-sankalpa]');
    var invalid = panel && panel.querySelector(':invalid');
    if (!invalid) return; // something else is invalid; let the browser handle it
    e.preventDefault();
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    panel.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    // Let the scroll settle before the browser anchors its validation bubble.
    setTimeout(function () { invalid.focus(); form.reportValidity(); }, smooth ? 320 : 0);
  });

  /* ---- Variant change: swap price / availability ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var root = sel.closest('[data-product]');
    if (!root) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = root.querySelector('[data-price-display]');
    var compareEl = root.querySelector('[data-compare-display]');
    var saveEl = root.querySelector('[data-save-display]');
    var addLabel = root.querySelector('[data-add-label]');
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    if (compareEl) compareEl.textContent = opt.dataset.compare || '';
    if (saveEl) {
      if (opt.dataset.compare) { saveEl.removeAttribute('hidden'); }
      else { saveEl.setAttribute('hidden', ''); }
    }
    if (addLabel) addLabel.textContent = (opt.dataset.available === 'true') ? 'Add to Cart' : 'Sold Out';
  });

  /* ---- PDP gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.k-pdp__thumb');
    if (!thumb) return;
    var main = document.getElementById('k-pdp-main');
    if (main && thumb.dataset.thumb) main.src = thumb.dataset.thumb;
    document.querySelectorAll('.k-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---- Collection sort ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---- Booking countdown (PDP) ----
     The deadline arrives as a server-resolved epoch in data-countdown-ends (see the
     comment at the top of sections/k-product.liquid), so ticking it down is plain
     arithmetic against the visitor's clock — no timezone guessing here. When the
     window lapses we flip the box to its closed state and strip the buy controls,
     so a tab left open overnight can't book a pooja that has already started.
     The server-rendered state on load stays the authority: a visitor with a badly
     wrong system clock sees wrong digits, but the real gate is that Liquid won't
     render a booking button for a lapsed product at all. */
  var countdowns = document.querySelectorAll('[data-countdown]');
  if (countdowns.length) {
    var UNITS = { days: 86400, hours: 3600, minutes: 60, seconds: 1 };

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    var closeBooking = function (cd) {
      cd.classList.add('is-over');
      var form = cd.closest('.k-pdp__form');
      if (!form) return;
      var book = form.querySelector('[data-book-now]');
      if (book) book.remove();
      // The dynamic checkout button skips the cart entirely — it can't outlive the window.
      var buynow = form.querySelector('.k-pdp__buynow');
      if (buynow) buynow.remove();
      var add = form.querySelector('.k-pdp__add');
      if (add) { add.disabled = true; add.classList.remove('is-loading'); }
      var label = form.querySelector('[data-add-label]');
      if (label && cd.dataset.countdownClosedLabel) label.textContent = cd.dataset.countdownClosedLabel;
    };

    // Returns how many timers are still running, so the interval can retire itself.
    var tick = function () {
      var now = Math.floor(Date.now() / 1000);
      var live = 0;
      countdowns.forEach(function (cd) {
        var ends = parseInt(cd.dataset.countdownEnds, 10);
        if (!ends) return;
        var left = ends - now;
        if (left <= 0) {
          if (!cd.classList.contains('is-over')) closeBooking(cd);
          return;
        }
        live++;
        var rest = left;
        Object.keys(UNITS).forEach(function (unit) {
          var size = UNITS[unit];
          var value = Math.floor(rest / size);
          rest -= value * size;
          var el = cd.querySelector('[data-countdown-' + unit + ']');
          if (el && el.textContent !== pad(value)) el.textContent = pad(value);
        });
      });
      return live;
    };

    var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    tick();
  }
})();
